import { render, staticRenderFns } from "./LeaveTypeList.vue?vue&type=template&id=aa148010&scoped=true"
import script from "./LeaveTypeList.vue?vue&type=script&lang=js"
export * from "./LeaveTypeList.vue?vue&type=script&lang=js"
import style0 from "./LeaveTypeList.vue?vue&type=style&index=0&id=aa148010&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa148010",
  null
  
)

export default component.exports